import { useMemo } from "react";

import type { NautilusApi } from "./nautilusApiTypes.ts";

type CreateOptions = {
  hostId: string;
  api: NautilusApi;
};

export const useBackendApi = ({ hostId, api }: CreateOptions) =>
  useMemo(
    () => ({
      getPermissions: () => api.permissions.get(), // may be module-specific in the future?
      getNodeDesigns: () => api.nodeDesigns.get({ params: { hostId } }),
      applyRevision: (payload: Parameters<typeof api.nodeDesigns.applyRevision>[0]) =>
        api.nodeDesigns.applyRevision(payload, { params: { hostId } }),
      undo: (revision: number) => api.nodeDesigns.undo({ params: { hostId, revision } }),
      redo: (revision: number) => api.nodeDesigns.redo({ params: { hostId, revision } }),
    }),
    [api, hostId],
  );

export type BackendApi = ReturnType<typeof useBackendApi>;
